/**
 * Created by harry on 28.04.17.
 */

'use strict';

module.exports = {
    data: {},
    favoriteList: []
};
